import ClientLogos from "./clientLogos";

const ClientShowcase = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <h3 className="mt-2xl px-xl text-center text-lg font-bold leading-tight md:mt-4xl md:px-0 md:pt-2xl md:text-xl">
        Some of the clients we have worked with
      </h3>
      <div className="mx-auto mt-lg text-center md:mt-4xl md:w-5/6">
        <ClientLogos />
      </div>
    </div>
  );
};

export default ClientShowcase;
